import createVueApp from '@/common/createApp'

Styxie.Initializers.MlapProjectsTerritories = {
  index: async(props) => {
    const { default: Territories } = await import('@/vue_widgets/mlap/territories/index.vue')
    createVueApp(Territories, { props })
  }
}
